import { render, staticRenderFns } from "./CMBankAccountsList.vue?vue&type=template&id=227250d6&scoped=true&"
import script from "./CMBankAccountsList.vue?vue&type=script&lang=js&"
export * from "./CMBankAccountsList.vue?vue&type=script&lang=js&"
import style0 from "./CMBankAccountsList.vue?vue&type=style&index=0&id=227250d6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "227250d6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\wamp64\\www\\corpmessengerwebapp_rtp\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('227250d6')) {
      api.createRecord('227250d6', component.options)
    } else {
      api.reload('227250d6', component.options)
    }
    module.hot.accept("./CMBankAccountsList.vue?vue&type=template&id=227250d6&scoped=true&", function () {
      api.rerender('227250d6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/bankAccounts/CMBankAccountsPage/CMBankAccountsList.vue"
export default component.exports